<ion-item *ngIf="callcard.location">
  <ion-icon (click)="onLocalize()" name="location" size="large" slot="start"></ion-icon>

  <ion-label class="ion-text-wrap" (click)="onLocalize()">
    <h2 *ngFor="let detail of callcard.location.FormattedLocation">{{ detail }}</h2>
    <h2 *ngIf="callcard.location.Complement">{{ callcard.location.Complement }}</h2>
    <h2 *ngIf="callcard.location.Narrative">{{ callcard.location.Narrative }}</h2>
  </ion-label>

  <ng-container *ngIf="enableInteraction">
    <ion-button *ngFor="let tool of navigationTools.tools" (click)="tool.navigateTo(callcard.location)" slot="end" fill="clear">
      <ion-icon [icon]="tool.icon" size="large" slot="icon-only"></ion-icon>
    </ion-button>
  </ng-container>
</ion-item>
